"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deprecatedLayoutPropDefs = exports.layoutPropDefs = void 0;
const padding_props_js_1 = require("./padding.props.js");
const height_props_js_1 = require("./height.props.js");
const width_props_js_1 = require("./width.props.js");
const positionValues = ['static', 'relative', 'absolute', 'fixed', 'sticky'];
// prettier-ignore
const positionEdgeValues = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-1', '-2', '-3', '-4', '-5', '-6', '-7', '-8', '-9'];
const flexShrinkValues = ['0', '1'];
const flexGrowValues = ['0', '1'];
const layoutPropDefs = {
    ...padding_props_js_1.paddingPropDefs,
    ...width_props_js_1.widthPropDefs,
    ...height_props_js_1.heightPropDefs,
    position: {
        type: 'enum',
        className: 'rt-r-position',
        values: positionValues,
        default: undefined,
        responsive: true,
    },
    inset: {
        type: 'enum | string',
        className: 'rt-r-inset',
        customProperties: ['--inset'],
        values: positionEdgeValues,
        default: undefined,
        responsive: true,
    },
    top: {
        type: 'enum | string',
        className: 'rt-r-top',
        customProperties: ['--top'],
        values: positionEdgeValues,
        default: undefined,
        responsive: true,
    },
    right: {
        type: 'enum | string',
        className: 'rt-r-right',
        customProperties: ['--right'],
        values: positionEdgeValues,
        default: undefined,
        responsive: true,
    },
    bottom: {
        type: 'enum | string',
        className: 'rt-r-bottom',
        customProperties: ['--bottom'],
        values: positionEdgeValues,
        default: undefined,
        responsive: true,
    },
    left: {
        type: 'enum | string',
        className: 'rt-r-left',
        customProperties: ['--left'],
        values: positionEdgeValues,
        default: undefined,
        responsive: true,
    },
    flexBasis: {
        type: 'string',
        className: 'rt-r-fb',
        customProperties: ['--flex-basis'],
        default: undefined,
        responsive: true,
    },
    flexShrink: {
        type: 'enum | string',
        className: 'rt-r-fs',
        customProperties: ['--flex-shrink'],
        values: flexShrinkValues,
        default: undefined,
        responsive: true,
    },
    flexGrow: {
        type: 'enum | string',
        className: 'rt-r-fg',
        customProperties: ['--flex-grow'],
        values: flexGrowValues,
        default: undefined,
        responsive: true,
    },
    gridColumn: {
        type: 'string',
        className: 'rt-r-gc',
        customProperties: ['--grid-column'],
        default: undefined,
        responsive: true,
    },
    gridColumnStart: {
        type: 'string',
        className: 'rt-r-gcs',
        customProperties: ['--grid-column-start'],
        default: undefined,
        responsive: true,
    },
    gridColumnEnd: {
        type: 'string',
        className: 'rt-r-gce',
        customProperties: ['--grid-column-end'],
        default: undefined,
        responsive: true,
    },
    gridRow: {
        type: 'string',
        className: 'rt-r-gr',
        customProperties: ['--grid-row'],
        default: undefined,
        responsive: true,
    },
    gridRowStart: {
        type: 'string',
        className: 'rt-r-grs',
        customProperties: ['--grid-row-start'],
        default: undefined,
        responsive: true,
    },
    gridRowEnd: {
        type: 'string',
        className: 'rt-r-gre',
        customProperties: ['--grid-row-end'],
        default: undefined,
        responsive: true,
    },
};
exports.layoutPropDefs = layoutPropDefs;
const deprecatedLayoutPropDefs = {
    /** @deprecated Rename this prop to `flexShrink`. The `shrink` prop will be removed in the next major release. */
    shrink: {
        type: 'enum | string',
        className: 'rt-r-fs',
        customProperties: ['--flex-shrink'],
        values: flexShrinkValues,
        default: undefined,
        responsive: true,
    },
    /** @deprecated Rename this prop to `flexGrow`. The `grow` prop will be removed in the next major release. */
    grow: {
        type: 'enum | string',
        className: 'rt-r-fg',
        customProperties: ['--flex-grow'],
        values: flexGrowValues,
        default: undefined,
        responsive: true,
    },
};
exports.deprecatedLayoutPropDefs = deprecatedLayoutPropDefs;
//# sourceMappingURL=layout.props.js.map